import { useRouter } from 'next/router';
import { useContext } from 'react';

import { connectToMetamask } from '@/apis/blockchain/blockchainCommon';
import { Web3Context } from '@/contexts/Web3Provider/Web3Provider';
import useAccessToken from '@/hooks/useAccessToken';

type TryToAuthorizeParam = {
  redirectTarget: Record<string, string>;
};
export type TryToAuthorizeType = (
  params: TryToAuthorizeParam
) => Promise<boolean>;

const useTryToAuthorize = (): TryToAuthorizeType => {
  const router = useRouter();

  const {
    currentAccountAddress,
    web3: { metamaskInstalled, metamaskProvider },
  } = useContext(Web3Context);
  const { accessToken, requestSignature } = useAccessToken();

  return async ({ redirectTarget }: TryToAuthorizeParam) => {
    // There is a pattern that `accessToken` exists but `currentAccountAddress` does not, so check both.
    if (accessToken && currentAccountAddress) return true;

    if (currentAccountAddress) {
      // `requestSignature` fetches `accessToken` and
      // sets it to the common header definition of the http client
      return await requestSignature();
    }

    if (!metamaskInstalled) {
      await router.push(
        `/connect-wallet?${new URLSearchParams(redirectTarget)}`
      );
      return false;
    }

    try {
      await connectToMetamask(metamaskProvider);
    } catch (e) {
      return false;
    }

    if (accessToken) {
      return true;
    } else {
      // `requestSignature` uses the data retrieved from react hooks.
      // You cannot run `requestSignature` here because that data is not updated until the next lifecycle.
      // The structure needs to be heavily refactored to make this work well,
      // so I simply reload the screen and prompt the end user to re-do
      window.location.reload();
      return false;
    }
  };
};

export default useTryToAuthorize;
